module.exports = __webpack_public_path__ + "static/media/6.82a7c56f.jpg";